import { queryOptions } from "@tanstack/react-query";
import type { InferResponseType } from "hono/client";
import { api, unwrap } from "@/client/lib/api";

export type Task = InferResponseType<(typeof api.tasks)[":id"]["$get"], 200>;

export type ActivityLine = InferResponseType<
  (typeof api.tasks)[":id"]["activity"]["$get"],
  200
>["items"][number];

/** The one task the panel shows, with the notes the working set leaves out. */
export const taskQuery = (id: string) =>
  queryOptions({
    queryKey: ["task", id],
    queryFn: (): Promise<Task> =>
      unwrap(api.tasks[":id"].$get({ param: { id } })),
  });

export const taskActivityQuery = (id: string) =>
  queryOptions({
    queryKey: ["task", id, "activity"],
    queryFn: async (): Promise<ActivityLine[]> =>
      (await unwrap(api.tasks[":id"].activity.$get({ param: { id } }))).items,
  });
